import { makeRequest } from 'utils/requestLogger';

export const refreshFeedback = (id) =>
  makeRequest('put', `/api/participations/${id}/refresh-feedback`);
export const selectFeedback = (id, payload) =>
  makeRequest('put', `/api/participations/${id}/select-feedback`, payload);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/automated_feedback/index.js